import React from 'react';
import { usePresentation } from '@/context/PresentationContext';

/** Inline text elements that automatically apply presentation masking. */
export function MemberName({ name, className }) {
    const { maskName } = usePresentation();
    return <span className={className}>{maskName(name)}</span>;
}

export function HouseholdName({ name, className }) {
    const { maskHousehold } = usePresentation();
    return <span className={className}>{maskHousehold(name)}</span>;
}

export function DoctorName({ name, className }) {
    const { maskDoctor } = usePresentation();
    return <span className={className}>{maskDoctor(name)}</span>;
}

/** Renders age from DOB in presentation mode, otherwise the raw DOB text. */
export function DobOrAge({ dob, className }) {
    const { maskDob } = usePresentation();
    return <span className={className}>{maskDob(dob)}</span>;
}

/** Renders free-text (care notes, board notes, hero card msgs, write-ins).
 * When ON, replaces with "Hidden in presentation mode". Otherwise renders
 * `children` (a linkified node) or the fallback string. */
export function FreeText({ children, fallback = '', className }) {
    const { on } = usePresentation();
    if (on) {
        return (
            <span className={className} data-testid="presentation-hidden">
                <em className="text-slate-400 not-italic">Hidden in presentation mode</em>
            </span>
        );
    }
    return <span className={className}>{children ?? fallback}</span>;
}

/** Coordinator-authored short strings (title, subject line). Truncates to 40 chars in presentation. */
export function Summary({ text, className, maxLen = 40 }) {
    const { maskSummary } = usePresentation();
    return <span className={className}>{maskSummary(text, maxLen)}</span>;
}
